import React from 'react'

import './styles.scss'

// TODO: remove later
const MOCK_DATA = {
  '100K_150': '7.000000000000001%',
  '30K_50K': '28.000000000000004%',
  '50K_74K': '20.0%',
  '75K_99K': '11.0%',
  GT_150K: '5.0%',
  LT_30K: '28.999999999999996%',
  others: '0.0%',
}

const Bar = ({ value }) => {
  const int = Math.round(parseFloat(value))
  const percent = parseFloat(value) / 100

  return (
    <>
      <div className="percent-bar">
        <div className="percent-fill" style={{ '--percent-fill': percent }}></div>
      </div>
      {int}%
    </>
  )
}

const TableView = ({ data = MOCK_DATA, title = 'MOCK_TITLE' }) => {
  const entries = Object.entries(data)
  return (
    <div className="table-view">
      <div className="row">
        <div className="cell">{title}</div>
        <div className="cell">Percentage</div>
      </div>
      <For each="entry" of={entries}>
        <div className="row" key={entry[0]}>
          <div className="cell">{entry[0]}</div>
          <div className="cell">
            <Bar value={entry[1]} />
          </div>
        </div>
      </For>
    </div>
  )
}

export default TableView
